import React from "react";
import axios from "axios";

import { apiGTFSv2, authorizationHeaderApiGTFSv2, axiosHeaders, configAgencyName } from "../config";
import { useAppDispatch } from "../redux/hooks";
import { dispatchAdditionalDataPKS } from "../redux/actions";

// Todo: Does it need to be refactored?
const useAdditionalData = (): (() => void) => {
  const dispatch: Dispatch = useAppDispatch();

  //* Connect to PKS express Api
  const getAdditionalDataGTFS: () => Promise<void> = React.useCallback(async (): Promise<void> => {
    //* Variables to dispatch
    let feedInfoToDispatch: string = "";
    let tripsDataToDispatch = [] as RoutesTripsData[];
    let quantityToDispatch = 0 as number;
    let subcontractorsPKSToDispatch = [] as string[];
    let feedStartDate: number = 0;
    let feedEndDate: number = 0;

    try {
      //* 1. Get feed_info
      const { data, status } = await axios.post(
        `${apiGTFSv2}/get_data`,
        { configAgencyName: configAgencyName },
        {
          headers: { ...axiosHeaders, Authorization: `Basic ${authorizationHeaderApiGTFSv2}` },
        }
      );
      if (status === 200) {
        // console.log("data:", data);
        feedInfoToDispatch = data?.feedInfo ?? "";
        feedStartDate = data?.startDate ?? 0;
        feedEndDate = data?.endDate ?? 0;
        // console.log({ feedStartDate, feedEndDate });
      }

      //* 2. Get routesTrips info
      const routeTripsRes = await axios.post(
        `${apiGTFSv2}/get_trips`,
        { configAgencyName: configAgencyName },
        {
          headers: { ...axiosHeaders, Authorization: `Basic ${authorizationHeaderApiGTFSv2}` },
        }
      );
      if (routeTripsRes?.status === 200) {
        const { tripsData } = routeTripsRes?.data || {};
        const { quantity } = routeTripsRes?.data || {};
        // console.log({ tripsData, quantity });
        tripsDataToDispatch = [...tripsData];
        quantityToDispatch = quantity;
      }

      //* 3. Get additionalData.json for PKS
      const additionalDataRes = await axios.post(
        `${apiGTFSv2}/get_additional_data`,
        { configAgencyName: configAgencyName },
        {
          headers: { ...axiosHeaders, Authorization: `Basic ${authorizationHeaderApiGTFSv2}` },
        }
      );
      if (additionalDataRes?.status === 200) {
        const subcontractorsPKS = additionalDataRes?.data?.dataToSend?.subcontractorsPKS;
        // console.log("subcontractorsPKS:", subcontractorsPKS);
        subcontractorsPKSToDispatch = subcontractorsPKS ? [...subcontractorsPKS] : [];
      }
    } catch (error) {
      // console.log("error:", error);
      if (axios.isAxiosError(error)) {
        if (error.response) {
          console.error(error.response.data);
          console.error(error.response.status);
          console.error(error.response.headers);
        } else if (error.request) {
          console.error(error.request);
        } else {
          console.error("Error", error.message);
        }
      }
      throw new Error("Error");
    } finally {
      // console.log("feedInfoToDispatch:", feedInfoToDispatch);
      // console.log("tripsDataToDispatch:", tripsDataToDispatch);
      // console.log("quantityToDispatch:", quantityToDispatch);
      // console.log("subcontractorsPKSToDispatch:", subcontractorsPKSToDispatch);
      // console.log({ feedStartDate, feedEndDate });

      dispatch(
        dispatchAdditionalDataPKS({
          feedInfoToSet: feedInfoToDispatch,
          tripsData: tripsDataToDispatch,
          quantity: quantityToDispatch,
          subcontractorsPKS: subcontractorsPKSToDispatch,
          feedStartDate: feedStartDate,
          feedEndDate: feedEndDate,
        })
      );
    }
  }, [dispatch]);

  return getAdditionalDataGTFS;
};

export default useAdditionalData;
